import {useLocation} from "react-router-dom";
import {useTranslation, withTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import _ from "lodash";
import {Timeline} from "antd";

function Tek4Eso(props) {
    const {t} = useTranslation();
    const [timelineData, setTimelineData] = useState([]);

    const {search} = useLocation();
    const year = +new URLSearchParams(search).get('year');

    const getPoints = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });
        if (mResult && mResult[0]) {
            if (mResult[0].points === 999) {
                return 999;
            }

        }
        return 0;
    }
    const getResponse = (code) => {


        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });
        if (mResult && mResult[0]) {
            if (mResult[0].assessment.questionType === "MULTIPLE3" || mResult[0].assessment.questionType === "MULTIPLE2" || mResult[0].assessment.questionType === "MULTIPLE4") {
                let mText = mResult[0].subanswers.map(sub => sub.response.question).join(', ')

                return mText

            } else {
                if (mResult[0].response) {
                    return mResult[0]?.response?.question
                } else {
                    if (mResult[0].degree) {
                        return mResult[0]?.degree?.title
                    }else{
                        if (mResult[0].subject) {
                            return mResult[0]?.subject?.subject
                        }
                    }
                }
            }
        } else {
            return "";
        }
    }

    const getResponseSubject = (code, pos) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]) {
            if (pos === 0) {
                return mResult[0]?.subject?.subject
            }
            let order = _.orderBy(mResult[0]?.subanswers, ["subject.order"], ['asc']);

            if (pos === 1) {
                return order[0]?.subject?.subject + ", " + order[1]?.subject?.subject
            }
            if (pos === 2) {
                return order[2]?.subject?.subject
            }
        } else {
            return "";
        }
    }


    const getResponseModality = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]) {

                return mResult[0]?.subject?.modality


        } else {
            return "";
        }
    }

    useEffect(() => {
        let mTimeline =
            [
                {
                    color: '#20388F',
                    date: '20' + year + ' - 20' + (year + 1),
                    message: '<strong>' + t("tengo") + '</strong>: ' + getResponse(2) + '<br />'
                        + '<strong>' + t("tek.duranteeste") + '</strong>: ' + getResponse(3) + '<br /><br />'
                        + '<strong>' + t("tek.piensoq") + '</strong>: ' + getResponse(4) + '<br /><br />'
                        + '<strong>' + t("tek.miitinerario") + '</strong>: ' + ((year < 23) ?
                        getResponse(5) : (getResponse(5) + '<br />' + getResponse(6)) + '<br /><br />')
                },
                {
                    color: '#52C41A',
                    date: '20' + (year + 1) + ' - 20' + (year + 2),
                    message: '<strong>' + t("tek.losestudios") + '</strong>: ' + getResponse(year < 23 ? 6 : 7) + '<br />'
                        + (getPoints(year < 23?  7 : 8) !== 999 ? '<strong>' + t("tek.mcfm") + '</strong>: ' + getResponse(year < 23?  7 : 8) + '<br /><br />' : '<br />')
                        + (getPoints(9) !== 999 ? '<strong>' + t("tek.mbtx") + '</strong>: ' + getResponse(year < 23 ? 9 : 10) + '<br /><br />' : '<br />')
                        + (getPoints(year < 23 ? 10 : 11) !== 999 ? '<strong>' + t("tek.mitroncal") + '</strong>: ' + getResponseSubject(year < 23 ? 10 : 11, 0) + '<br />' : '')
                        + (getPoints(year < 23 ? 10 : 11) !== 999 ? '<strong>' + t("tek.miespec") + '</strong>: ' + getResponseSubject(year < 23 ? 10 : 11, 1) + '<br />' : '')
                        + (getPoints(year < 23 ? 10 : 11) !== 999 ? '<strong>' + t("tek.miopta") + '</strong>: ' + getResponseSubject(year < 23 ? 10 : 11, 2) + '<br />' : '')
                },
                {
                    color: '#F5222D',
                    date: '20' + (year + 2) + ' - 20' + (year + 3),
                    message: (getPoints(year < 23 ? 7 : 8) !== 999 ? '<strong>' + t("tek.segundog") + '</strong>: ' + getResponse(year < 23 ? 7 : 8) + '<br /><br />' : '<br />')
                        + (getPoints(year < 23 ? 9 : 10 ) !== 999 ? '<strong>' + t("tek.segundob") + '</strong>: ' + getResponse(year < 23 ? 9 : 10) + '<br /><br />' : '<br />')
                },
                {
                    color: '#20388F',
                    date: '20' + (year + 3) + ' - 20' + (year + 4),
                    message: (getPoints(7) !== 999 ? '<strong>' + t("tek.encasocfgm") + '</strong>: ' + getResponse(year < 23 ? 8 : 9) + '<br /><br />' : '<br />')
                        + (getPoints(year < 23 ? 9 : 10) !== 999 ? '<strong>' + t("tek.encasobacn") + '</strong>: ' + getResponse(year <  23 ? 11 : 12) + '<br /><br />' : '<br />')
                        + (getPoints(year < 23 ? 12 : 13) !== 999 ? '<strong>' + t("tek.micfgs") + '</strong>: ' + getResponse(year < 23 ? 12 : 13) + '<br /><br />' : '<br />')
                        + (getPoints(year < 23 ? 13 : 14) !== 999 ? '<strong>' + t("tek.miuni") + '</strong>: ' + getResponse(year < 23 ? 13 : 14) + '<br /><br />' : '<br />')
                }
            ];
        props.setTimeline(mTimeline)
        setTimelineData(mTimeline)
    }, [year])

    return (
        <>
            {!props.forDownload &&
                <Timeline mode={'left'}>
                    {timelineData.map(item => <Timeline.Item color={item.color} key={item.date} label={item.date}>
                            <p dangerouslySetInnerHTML={{__html: item.message}}/>
                        </Timeline.Item>
                    )}
                </Timeline>
            }
        </>
    );
}

export default withTranslation()(Tek4Eso);
